module.exports = "/_next/static/images/easycover-eedd37041189638c6a0d4d31f0ca4580.svg";